
import {
  ICustomProperty, IOperatorReplacement, IPromptMessages,
  IFunctionObject, IDeclarationObject,
  IPointAccount, IGradeHierarchy
} from '../index.d';
import StupiddDatePickerStore from '../components/stupid-date-picker/store';
import { replaceMemberPointAccount, replaceMemberGradeHierarchy, replaceMemberGradeHierarchyGradeId } from './current-member';
import { replaceFqnProperties } from './fqn-property';
import { replaceFunctionName } from './function';
import { replaceLogicOperator } from './logic-operator';
import { replaceCustomProperty } from './custom-property';
import { replaceDateLikeFunction } from './date';
import { replaceEnumOptionText } from './enum-boolean';
import { replaceAtomIdArray } from './id-array';
import { replaceDeclarationSelector } from './selector';
import { replaceDeclarationSelectorValue } from './selector-value';
import { replacePlacehoder } from './placeholder';
import { replaceProxy } from './proxy';


// 将指定的 Token 替换成其他文案
export default function replaceTextWithElement(options: {
  fqn: any,
  cm: CodeMirror.Editor,
  functions: IFunctionObject[],
  declarations: IDeclarationObject[],
  datePickerStore: StupiddDatePickerStore | { isPreviewMode: boolean },
  customProperties: ICustomProperty[],
  operatorReplacements: IOperatorReplacement[],
  promptMessages: IPromptMessages,
  pointAccounts: IPointAccount[],
  gradeHierarchies: IGradeHierarchy[],
  showDescription: boolean
}) {
  const { cm, fqn, datePickerStore,
    functions, customProperties,
    operatorReplacements, promptMessages,
    pointAccounts, gradeHierarchies, showDescription
  } = options;
  const doc = cm.getDoc();

  const declarations = options.declarations;

  // 清除所有的标记替换
  doc.getAllMarks().forEach(marker => {
    // 时间日期、ID等类型会监听点击事件，需要手动清除
    const { replacedWith } = (marker as any);

    if (replacedWith && replacedWith.removeMarkerListener) {
      replacedWith.removeMarkerListener();
    }

    marker.clear();
  });

  doc.eachLine((lineHandle) => {
    const line = (lineHandle as any).lineNo();
    const tokens = cm.getLineTokens(line);

    let i = 0;

    while (tokens[i]) {

      const couter1 = replaceFqnProperties({
        editor: cm, tokens, idx: i, showDescription, fqn
      });
      if (couter1 > 0) {
        i += couter1;
        continue;
      }

      const couter2 = replaceMemberPointAccount(cm, tokens[i], pointAccounts, promptMessages);
      if (couter2 > 0) {
        i += couter2;
        continue;
      }

      const couter3 = replaceMemberGradeHierarchy(cm, tokens[i], gradeHierarchies, promptMessages);
      if (couter3 > 0) {
        i += couter3;
        continue;
      }

      const couter4 = replaceMemberGradeHierarchyGradeId(cm, tokens, i, gradeHierarchies, customProperties);
      if (couter4 > 0) {
        i += couter4;
        continue;
      }

      const couter5 = replaceFunctionName(cm, tokens, i, functions);
      if (couter5 > 0) {
        i += couter5;
        continue;
      }

      const couter6 = replaceLogicOperator(cm, tokens, i, operatorReplacements);
      if (couter6 > 0) {
        i += couter6;
        continue;
      }

      const couter7 = replaceCustomProperty(cm, tokens, i, customProperties, promptMessages);
      if (couter7 > 0) {
        i += couter7;
        continue;
      }

      const couter8 = replaceDateLikeFunction(cm, tokens[i], datePickerStore as StupiddDatePickerStore);
      if (couter8 > 0) {
        i += couter8;
        continue;
      }

      const couter9 = replaceEnumOptionText(cm, tokens, i, customProperties);
      if (couter9 > 0) {
        i += couter9;
        continue;
      }

      const AtomIdArrayCounter = replaceAtomIdArray(cm, tokens, i);
      if (AtomIdArrayCounter > 0) {
        i += AtomIdArrayCounter;
        continue;
      }


      const Selector = declarations.find(item => item.code === 'Selector');
      if (Selector) {
        const DeclarationSelectorCounter = replaceDeclarationSelector(cm, tokens, i, Selector.oninit);
        if (DeclarationSelectorCounter > 0) {
          i += DeclarationSelectorCounter;
          continue;
        }
      }

      const SelectorValue = declarations.find(item => item.code === 'SelectorValue');
      if (SelectorValue) {
        const DeclarationSelectorValueCounter = replaceDeclarationSelectorValue(cm, tokens, i, SelectorValue.oninit);
        if (DeclarationSelectorValueCounter > 0) {
          i += DeclarationSelectorValueCounter;
          continue;
        }
      }

      const placeholderCounter = replacePlacehoder(cm, tokens, i);
      if (placeholderCounter > 0) {
        i += placeholderCounter;
        continue;
      }

      const proxyCounter = replaceProxy(cm, tokens, i);
      if (proxyCounter > 0) {
        i += proxyCounter;
        continue;
      }

      i++;
    }

  });
}
